import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_3 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_4 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_5 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_6 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_7 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_8 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_9 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_10 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }
const _hoisted_11 = { class: "p-field p-col p-col-12 p-md-4 p-lg-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Panel, { header: "Thêm nhóm" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[8] || (_cache[8] = _createElementVNode("label", null, "Tên nhóm", -1)),
            _createVNode(_component_InputText, {
              id: "groupname",
              type: "text",
              modelValue: $setup.groupCreate.groupName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.groupCreate.groupName) = $event)),
              style: {"text-align":"center"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _cache[9] || (_cache[9] = _createElementVNode("label", null, "Thêm nhóm", -1)),
            _createVNode(_component_Button, {
              label: "Thêm",
              icon: "pi pi-plus-circle",
              iconPos: "left",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.addGroup())),
              disabled: !$setup.groupCreate.groupName
            }, null, 8, ["disabled"])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Panel, { header: "Thêm thành viên vào nhóm" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[10] || (_cache[10] = _createElementVNode("label", null, "Chọn nhóm", -1)),
            _createVNode(_component_Dropdown, {
              id: "groupselect",
              modelValue: $setup.idGroup,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.idGroup) = $event)),
              options: $setup.listGroup,
              optionLabel: "groupName",
              optionValue: "id",
              filter: true
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[11] || (_cache[11] = _createElementVNode("label", null, "Chọn thành viên", -1)),
            _createVNode(_component_Dropdown, {
              id: "memberselect",
              modelValue: $setup.idCustomer,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.idCustomer) = $event)),
              options: $setup.listCustomer,
              optionLabel: "name",
              optionValue: "idMember",
              filter: true
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[12] || (_cache[12] = _createElementVNode("label", null, "Thêm thành viên vào nhóm", -1)),
            _createVNode(_component_Button, {
              label: "Thêm",
              icon: "pi pi-plus-circle",
              iconPos: "left",
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.addMember())),
              disabled: !($setup.idGroup && $setup.idCustomer)
            }, null, 8, ["disabled"])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Panel, { header: "Xóa thành viên ra khỏi nhóm" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[13] || (_cache[13] = _createElementVNode("label", null, "Chọn nhóm", -1)),
            _createVNode(_component_Dropdown, {
              id: "groupselectdelete",
              modelValue: $setup.idGroupDelete,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.idGroupDelete) = $event)),
              options: $setup.listGroup,
              optionLabel: "groupName",
              optionValue: "id",
              onChange: $setup.selectGroup,
              filter: true
            }, null, 8, ["modelValue", "options", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[14] || (_cache[14] = _createElementVNode("label", null, "Chọn thành viên", -1)),
            _createVNode(_component_Dropdown, {
              id: "memberselectdelete",
              modelValue: $setup.idMemberDelete,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.idMemberDelete) = $event)),
              options: $setup.memberInGroup,
              optionLabel: "zaloName",
              optionValue: "id",
              filter: true
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[15] || (_cache[15] = _createElementVNode("label", null, "Xóa thành viên ra khỏi nhóm", -1)),
            _createVNode(_component_Button, {
              label: "Xóa",
              icon: "pi pi-trash",
              iconPos: "left",
              onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.deleteMember())),
              class: "p-button-danger",
              disabled: !($setup.idGroupDelete && $setup.idMemberDelete)
            }, null, 8, ["disabled"])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}